module.exports = __webpack_public_path__ + "assets/img/nature-time-bg-2.89e5780c.png";